export const SVG_COLORS: {[key: string]: string} = {
  deserttan  : '#daac82',
  gray       : '#a19d9e',
  navy       : '#173862',
  blue       : '#0253a5',
  lightblue  : '#22add9',
  purple     : '#765080',
  darkgreen  : '#006835',
  green      : '#00903f',
  lightgreen : '#a9d049',
  pink       : '#ed2d92',
  maroon     : '#a82327',
  red        : '#c52033',
  orange     : '#f05423',
  black      : '#000000',
  white      : '#FFFFFF',
}

export const SWATCH_COLORS: {[key: string]: string} = {
  deserttan  : '#daac82',
  gray       : '#a19d9e',
  navy       : '#173862',
  blue       : '#0253a5',
  lightblue  : '#22add9',
  purple     : '#765080',
  darkgreen  : '#006835',
  green      : '#00903f',
  lightgreen : '#a9d049',
  pink       : '#ed2d92',
  maroon     : '#a82327',
  red        : '#c52033',
  orange     : '#f05423',
  black      : '#000000',
  white      : '#FFFFFF',
  gold       : '#FFD700',
}

export const PRINTER_COLORS_HEX: {[key: string]: string} = {
  deserttan  : '#DAAC82',
  gray       : '#A19D9E',
  navy       : '#173862',
  blue       : '#0253A5',
  lightblue  : '#22ADD9',
  purple     : '#765080',
  darkgreen  : '#006835',
  green      : '#00903F',
  lightgreen : '#a9d049',
  pink       : '#ED2D92',
  maroon     : '#A82327',
  red        : '#C52033',
  orange     : '#F05423',
  black      : '#000000',
  white      : '#FFFFFF',
}

export const PRINTER_COLORS: {[key: string]: string} = {
  ...PRINTER_COLORS_HEX,
  tigerstripewoodlandcamo : 'tigerstripewoodlandcamo',
  tekgraycamo             : 'tekgraycamo',
}

export const getColor = (hex: string): string | undefined => Object.keys(PRINTER_COLORS).find(key => PRINTER_COLORS[key] === hex)

export type CustomBumperData = {
  productImage: string,
  colorOptions: { label: string, value: string }[],
  galleryImages: { src: string, weight: number }[],
  canvasImages: string[],
}

export const CUSTOM_BUMPER_DATA:{[key: string]: CustomBumperData} = {
  'IP0520-CST-Group': {
    productImage : '/zeus/assets/blackBumper_RevisedMats_R4_ng8t4w',
    colorOptions : [
      {
        label : 'White',
        value : 'white',
      },
      {
        label : 'Desert Tan',
        value : 'deserttan',
      },
      {
        label : 'Gray',
        value : 'gray',
      },
      {
        label : 'Navy',
        value : 'navy',
      },
      {
        label : 'Blue',
        value : 'blue',
      },
      {
        label : 'Light Blue',
        value : 'lightblue',
      },
      {
        label : 'Purple',
        value : 'purple',
      },
      {
        label : 'Dark Green',
        value : 'darkgreen',
      },
      {
        label : 'Green',
        value : 'green',
      },
      {
        label : 'Light Green',
        value : 'lightgreen',
      },
      {
        label : 'Pink',
        value : 'pink',
      },
      {
        label : 'Maroon',
        value : 'maroon',
      },
      {
        label : 'Red',
        value : 'red',
      },
      {
        label : 'Orange',
        value : 'orange',
      },
      {
        label : 'Camo',
        value : 'tigerstripewoodlandcamo',
      },
      {
        label : 'TekGray',
        value : 'tekgraycamo',
      },
    ],
    galleryImages: [
      { src: '/UI/zeus/bumpers/black_ohqp1w.png', weight: 55 },
      { src: '/UI/zeus/bumpers/black_ohqp1w.png', weight: 45 },
      { src: '/UI/zeus/bumpers/black_ohqp1w.png', weight: 35 },
      { src: '/UI/zeus/bumpers/black_ohqp1w.png', weight: 25 },
    ],
    canvasImages: [
      '/svc_spa/assets/custom/bumpers/black.png',
      '/svc_spa/assets/custom/bumpers/black.png',
      '/svc_spa/assets/custom/bumpers/black.png',
      '/svc_spa/assets/custom/bumpers/black.png',
    ],
  },
  'IP0516-CST-Group': {
    productImage : '/zeus/assets/color_45',
    colorOptions : [
      {
        label : 'White',
        value : 'white',
      },
      {
        label : 'Black',
        value : 'black',
      },
    ],
    galleryImages: [
      { src: '/UI/zeus/bumpers/color_55.png', weight: 55 },
      { src: '/UI/zeus/bumpers/color_45.png', weight: 45 },
      { src: '/UI/zeus/bumpers/color_35_hc1pgm.png', weight: 35 },
      { src: '/UI/zeus/bumpers/color_25_dbhsbq.png', weight: 25 },
    ],
    canvasImages: [
      '/svc_spa/assets/custom/bumpers/color_55.png',
      '/svc_spa/assets/custom/bumpers/color_45.png',
      '/svc_spa/assets/custom/bumpers/color_35.png',
      '/svc_spa/assets/custom/bumpers/color_25.png',
    ],
  },
  'IP0538-CST-Group': {
    productImage : '/UI/zeus/bumpers/black_urethane_thumb_bjyzql.png',
    colorOptions : [
      {
        label : 'White',
        value : 'white',
      },
      {
        label : 'Desert Tan',
        value : 'deserttan',
      },
      {
        label : 'Gray',
        value : 'gray',
      },
      {
        label : 'Navy',
        value : 'navy',
      },
      {
        label : 'Blue',
        value : 'blue',
      },
      {
        label : 'Light Blue',
        value : 'lightblue',
      },
      {
        label : 'Purple',
        value : 'purple',
      },
      {
        label : 'Dark Green',
        value : 'darkgreen',
      },
      {
        label : 'Green',
        value : 'green',
      },
      {
        label : 'Light Green',
        value : 'lightgreen',
      },
      {
        label : 'Pink',
        value : 'pink',
      },
      {
        label : 'Maroon',
        value : 'maroon',
      },
      {
        label : 'Red',
        value : 'red',
      },
      {
        label : 'Orange',
        value : 'orange',
      },
      {
        label : 'Camo',
        value : 'tigerstripewoodlandcamo',
      },
      {
        label : 'TekGray',
        value : 'tekgraycamo',
      },
    ],
    galleryImages: [
      { src: '/UI/zeus/bumpers/black_urethane_f25lpd.png', weight: 55 },
      { src: '/UI/zeus/bumpers/black_urethane_f25lpd.png', weight: 45 },
      { src: '/UI/zeus/bumpers/black_urethane_f25lpd.png', weight: 35 },
      { src: '/UI/zeus/bumpers/black_urethane_f25lpd.png', weight: 25 },
      { src: '/UI/zeus/bumpers/black_urethane_f25lpd.png', weight: 10 },
    ],
    canvasImages: [
      '/svc_spa/assets/custom/bumpers/black.png',
      '/svc_spa/assets/custom/bumpers/black.png',
      '/svc_spa/assets/custom/bumpers/black.png',
      '/svc_spa/assets/custom/bumpers/black.png',
      '/svc_spa/assets/custom/bumpers/black.png',
    ],
  },
  'IP0537-CST-Group': {
    productImage : '/UI/zeus/bumpers/color_urethane_thumb_z6bfcf.png',
    colorOptions : [
      {
        label : 'White',
        value : 'white',
      },
      {
        label : 'Black',
        value : 'black',
      },
    ],
    galleryImages: [
      { src: '/UI/zeus/bumpers/color_55_urethane_lfn5eb.png', weight: 55 },
      { src: '/UI/zeus/bumpers/color_45_urethane_tj2tsc.png', weight: 45 },
      { src: '/UI/zeus/bumpers/color_35_urethane_iqzd8y.png', weight: 35 },
      { src: '/UI/zeus/bumpers/color_25_urethane_lrwwpr.png', weight: 25 },
      { src: '/UI/zeus/bumpers/black_urethane_f25lpd.png', weight: 10 },
    ],
    canvasImages: [
      '/svc_spa/assets/custom/bumpers/color_55.png',
      '/svc_spa/assets/custom/bumpers/color_45.png',
      '/svc_spa/assets/custom/bumpers/color_35.png',
      '/svc_spa/assets/custom/bumpers/color_25.png',
      '/svc_spa/assets/custom/bumpers/black.png',
    ],
  },
  'IP0535-CST-Group': {
    productImage : '/UI/zeus/bumpers/HG2.0-TH_yji24w.png',
    colorOptions : [
      {
        label : 'White',
        value : 'white',
      },
      {
        label : 'Desert Tan',
        value : 'deserttan',
      },
      {
        label : 'Gray',
        value : 'gray',
      },
      {
        label : 'Navy',
        value : 'navy',
      },
      {
        label : 'Blue',
        value : 'blue',
      },
      {
        label : 'Light Blue',
        value : 'lightblue',
      },
      {
        label : 'Purple',
        value : 'purple',
      },
      {
        label : 'Dark Green',
        value : 'darkgreen',
      },
      {
        label : 'Green',
        value : 'green',
      },
      {
        label : 'Light Green',
        value : 'lightgreen',
      },
      {
        label : 'Pink',
        value : 'pink',
      },
      {
        label : 'Maroon',
        value : 'maroon',
      },
      {
        label : 'Red',
        value : 'red',
      },
      {
        label : 'Orange',
        value : 'orange',
      },
      {
        label : 'Camo',
        value : 'tigerstripewoodlandcamo',
      },
      {
        label : 'TekGray',
        value : 'tekgraycamo',
      },
    ],
    galleryImages: [
      { src: '/cms/zeus/Custom%20HG%20Bumpers/PNG/HG2.0_55lb_rrycln.png', weight: 55 },
      { src: '/cms/zeus/Custom%20HG%20Bumpers/PNG/HG2.0_45lb_anvwaf.png', weight: 45 },
      { src: '/cms/zeus/Custom%20HG%20Bumpers/PNG/HG2.0_35lb_girudv.png', weight: 35 },
      { src: '/cms/zeus/Custom%20HG%20Bumpers/PNG/HG2.0_25lb_vmn57i.png', weight: 25 },
      { src: '/cms/zeus/Custom%20HG%20Bumpers/PNG/HG2.0_15lb_djv26l.png', weight: 15 },
      { src: '/cms/zeus/Custom%20HG%20Bumpers/PNG/HG2.0_10lb_nc0nmc.png', weight: 10 },
    ],
    canvasImages: [
      '/svc_spa/assets/custom/bumpers/hg/55.png',
      '/svc_spa/assets/custom/bumpers/hg/45.png',
      '/svc_spa/assets/custom/bumpers/hg/35.png',
      '/svc_spa/assets/custom/bumpers/hg/25.png',
      '/svc_spa/assets/custom/bumpers/hg/15.png',
      '/svc_spa/assets/custom/bumpers/hg/10.png',
    ],
  },
}

export const CUSTOM_BUMPER_FONTS: {[key: string]: object} = {
  arimo: {
    name : 'Arimo',
    url  : 'https://fonts.googleapis.com/css2?family=Arimo:wght@700',
  },
  arvo: {
    name : 'Arvo',
    url  : 'https://fonts.googleapis.com/css2?family=Arimo:wght@700',
  },
  montserrat: {
    name : 'Montserrat',
    url  : 'https://fonts.googleapis.com/css2?family=Arimo:wght@700',
  },
}
